'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import HeroSection from './HeroSection';
import ClientLogos from './ClientLogos';
import ManufacturingExcellence from './ManufacturingExcellence';
import CTASection from './CTASection';
import Footer from './Footer';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleIndustrySelect = (industry: string) => {
    if (!isHydrated) return;
    
    if (industry === 'all' || industry === 'portfolio') {
      router.push('/solutions');
    } else {
      router.push(`/solutions#${industry}`);
    }
  };

  const handleRequestConsultation = () => {
    if (!isHydrated) return;
    router.push('/contact');
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-[600px] bg-gray-200"></div>
          <div className="container mx-auto px-4 py-16">
            <div className="space-y-8">
              <div className="h-64 bg-gray-200 rounded"></div>
              <div className="h-96 bg-gray-200 rounded"></div>
              <div className="h-64 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection onIndustrySelect={handleIndustrySelect} />
      <ClientLogos />
      <ManufacturingExcellence />
      <CTASection onRequestConsultation={handleRequestConsultation} />
      <Footer />
    </div>
  );
};

export default HomepageInteractive;